import * as _ from 'underscore';
import * as AlgorithmCriteria from 'algorithmCriteria';
import {whitelabelling as Whitelabelling} from 'whitelabelling';

const EXPERT_PITCH_LIMIT = 190;
const EXPERT_PITCH_LIMIT_EXPANDED = 10000;

export function matchedExpert() {
    return {
        restrict: 'E',
        scope: {
            consumer: '=',
            expert: '=',
            showSkipOption: '=?',
        },
        replace: true,
        templateUrl: Evisors.config.cdnRootWhitelabel + 'ng-template/partials/registration/directives/matchedExpert.tpl.html',
        controller: [
            '$scope', 'AlgorithmService', function($scope, AlgorithmService) {
                $scope.whitelabelling = Whitelabelling;
                $scope.criteriaList = [];

                // Number of characters we limit expert pitch to.
                $scope.expertPitchLimit = EXPERT_PITCH_LIMIT;
                $scope.toggleExpertPitchLimit = function() {
                    if ($scope.expertPitchLimit === EXPERT_PITCH_LIMIT) {
                        $scope.expertPitchLimit = EXPERT_PITCH_LIMIT_EXPANDED;
                    } else if ($scope.expertPitchLimit === EXPERT_PITCH_LIMIT_EXPANDED) {
                        $scope.expertPitchLimit = EXPERT_PITCH_LIMIT;
                    }
                };

                $scope.$watch('expert.id', loadExpertMatchInformation);

                $scope.triggerBooking = function() {
                    $scope.$emit('triggerBooking');
                };

                var criteriaToInclude = [
                    AlgorithmCriteria.CRITERIA_CURRENT_LOCATION,
                    AlgorithmCriteria.CRITERIA_GROUPS,
                    AlgorithmCriteria.CRITERIA_DESIRED_WORK_LOCATION,
                    AlgorithmCriteria.CRITERIA_DESIRED_EMPLOYER,
                    AlgorithmCriteria.CRITERIA_DESIRED_ROLE,
                    AlgorithmCriteria.CRITERIA_DESIRED_INDUSTRY,
                    AlgorithmCriteria.CRITERIA_YEARS_SENIOR,
                    AlgorithmCriteria.CRITERIA_RESPONDS_QUICKLY,
                    AlgorithmCriteria.CRITERIA_EXPERIENCED_EXPERT,
                    AlgorithmCriteria.CRITERIA_POSITIVELY_REVIEWED,
                ];

                // Fredrik doesn't want to show the suffix for the group criteria...
                $scope.GROUP_KEY = AlgorithmCriteria.CRITERIA_GROUPS;

                function loadExpertMatchInformation() {
                    if (!$scope.expert) {
                        $scope.criteriaList = [];
                        return;
                    }
                    // now we get the criteria list
                    $scope.criteriaList = AlgorithmService.getTopMatchCriteriaBetweenUsers(
                        $scope.expert,
                        $scope.consumer,
                        $scope.expert.get('topMatchContainer'),
                        criteriaToInclude,
                    );

                    // we want non-partials at the top
                    $scope.criteriaList = _.sortBy($scope.criteriaList, function(val) {
                        return val.isPartial ? 1 : 0;
                    });

                    $scope.relevantCriteria = _.filter($scope.criteriaList, function(item) {
                        return (item.matches && item.matches.length > 0);
                    });

                    // Scroll to the top of the element.
                    $scope.infoElement.scrollTop = 0;
                }

            },
        ],
        link: function(scope, element) {
            // Need this element to scroll every time we change the card.
            scope.infoElement = angular.element(element).children()[2];
        },
    };
}
